import type { QueryKey } from "@tanstack/react-query";

type I18nOptions<Locale extends string> = {
  locale: Locale;
};

function i18nQueryKey<const I18n extends I18nOptions<string>>(i18n: I18n) {
  return partialI18nQueryKey({
    i18n,
  });
}

function withI18nQueryKey<const Base extends QueryKey, const I18n extends I18nOptions<string>>(
  base: Base = [] as unknown as Base,
  i18n: I18n,
) {
  return partialI18nQueryKey({
    base,
    i18n,
  });
}

function partialI18nQueryKey<
  const Base extends QueryKey,
  const I18n extends I18nOptions<string>,
>(params?: { base?: Base | undefined; i18n?: I18n | undefined }) {
  const { base = [], i18n = {} } = params ?? {};
  return [...base, i18n] as Base extends readonly [unknown, ...unknown[]]
    ? [...Base, I18n]
    : [I18n];
}

export { i18nQueryKey, withI18nQueryKey };
